export const identityFormatter = value => value
export const accountTypeFormatter = value => {
  const words = value.split('_')
  words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1)
  return words.join(' ')
}
